import React from "react";

export const HowRevokeTrack: React.FC = () => {
  return <div id={"HowRevokeTrack"}>
    <h2>
      Как изъять отдельный трек в альбоме
    </h2>
    <ul className={"list-disc"}>
      <li>Откройте альбом и перенесите его в Черновик</li>
      <li>Перейдите на вкладку Трек-лист, найдите необходимый трек и нажмите на иконку корзины</li>
      <li>Сохраните изменения в Трек-листе и опубликуйте черновик</li>
    </ul>

    <p>Трек изъят из состава альбома и больше не будет отображаться в черновике.</p>
  </div>;
};
